// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Array from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as AbModificationState from "./AbModificationState.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as ModificationPreview from "../modification-preview/ModificationPreview.bs.js";
import * as AbEligibilityRulesForm from "./AbEligibilityRulesForm.bs.js";
import * as CreateModificationUtils from "../../../../library/utils/CreateModificationUtils.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";
import * as ProgressStepper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepper.bs.js";
import * as AbModificationStepperConfig from "./AbModificationStepperConfig.bs.js";
import * as AbModificationKeyDetailsForm from "./AbModificationKeyDetailsForm.bs.js";
import * as ProgressStepperHook$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepperHook.bs.js";
import * as AbModificationBaseDetailsForm from "./AbModificationBaseDetailsForm.bs.js";
import * as AbModificationSlabDetailsForm from "./AbModificationSlabDetailsForm.bs.js";

function resolveOption(data) {
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("AbModificationForm.re", "Data incomplete to show preview", undefined), undefined);
  }
}

function resolveOptionArray(data, len) {
  var res = Belt_Array.keep(data, (function (x) {
          return x !== undefined;
        }));
  if (res.length === len) {
    return Belt_Array.map(data, (function (x) {
                  return x;
                }));
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("AbModificationForm.re", "Data incomplete to show preview", undefined), undefined);
  }
}

var scrollTo = (function (ele, x, y) {
    if(ele)
      ele.scrollTo(x,y);
  });

var clientWidth = (function (ele) {
    if(ele)
      return ele.clientWidth;
    return 0;
  });

function scrollToRight(refrence) {
  var r = refrence.current;
  if (!(r == null)) {
    return scrollTo(r, clientWidth(r) + 10 | 0, 0);
  }
  
}

function scrollToLeft(refrence) {
  var r = refrence.current;
  if (!(r == null)) {
    return scrollTo(r, 0, 0);
  }
  
}

function AbModificationForm$AbModificationWrapper(Props) {
  var children = Props.children;
  var title = Props.title;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "c-ab-modification-wrapper-title"
                }, title), children);
}

var AbModificationWrapper = {
  make: AbModificationForm$AbModificationWrapper
};

function getTestGroup(id, key_details) {
  var ids = key_details !== undefined ? Belt_Array.get(key_details.test_ids, id - 1 | 0) : ErrorUtils$Catalyst.raiseError("AbModificationForm.res", "key details not found", String(id));
  if (id > 4 || id < 1) {
    return ErrorUtils$Catalyst.raiseError("AbModificationForm.res", "Invalid test group count", String(id));
  } else if (ids !== undefined) {
    return "Base Details  ( id : " + ids.start + "-" + ids.end + " )";
  } else {
    return ErrorUtils$Catalyst.raiseError("AbModificationForm.res", "index out of range", String(id));
  }
}

function AbModificationForm(Props) {
  var core_pricing = Props.core_pricing;
  var close_modal = Props.close_modal;
  var openConfirmationModal = Props.openConfirmationModal;
  var match = React.useState(function () {
        return AbModificationState.initial_state;
      });
  var updateState = match[1];
  var state = match[0];
  var match$1 = ProgressStepperHook$Catalyst.useStepper(AbModificationStepperConfig.steppers, /* KeyDetails */0, ProgressStepper$Catalyst.Classes.make(" create-modification-stepper-root", undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined);
  var resetStepper = match$1.resetStepper;
  var setCompleted = match$1.setCompleted;
  var setActive = match$1.setActive;
  var stepperRef = React.useRef(null);
  var tmp;
  switch (match$1.active) {
    case /* KeyDetails */0 :
        tmp = React.createElement(AbModificationKeyDetailsForm.make, {
              key_details: state.key_details,
              core_pricing_start_date: core_pricing.start_date,
              modification_type: /* AB */0,
              onNext: (function (details) {
                  Curry._1(updateState, (function (pre) {
                          return {
                                  key_details: details,
                                  base_details_test: pre.base_details_test,
                                  current_base_details_test: pre.current_base_details_test,
                                  base_details_control: pre.base_details_control,
                                  slab_details_test: pre.slab_details_test,
                                  current_slab_details_test: pre.current_slab_details_test,
                                  slab_details_control: pre.slab_details_control,
                                  eligiblity_rules: pre.eligiblity_rules
                                };
                        }));
                  Curry._1(setActive, /* BaseDetailsTest */1);
                  return Curry._1(setCompleted, /* KeyDetails */0);
                }),
              onBack: (function (param) {
                  return Curry._1(openConfirmationModal, undefined);
                })
            });
        break;
    case /* BaseDetailsTest */1 :
        var totalTestCount = Caml_format.caml_int_of_string(state.key_details.test_group);
        tmp = React.createElement(AbModificationForm$AbModificationWrapper, {
              children: React.createElement(AbModificationBaseDetailsForm.make, {
                    base_details: Belt_Array.getExn(state.base_details_test, state.current_base_details_test - 1 | 0),
                    core_pricing: core_pricing,
                    onNext: (function (details) {
                        Curry._1(updateState, (function (pre) {
                                return {
                                        key_details: pre.key_details,
                                        base_details_test: (Belt_Array.setExn(state.base_details_test, state.current_base_details_test - 1 | 0, details), state.base_details_test),
                                        current_base_details_test: pre.current_base_details_test,
                                        base_details_control: pre.base_details_control,
                                        slab_details_test: pre.slab_details_test,
                                        current_slab_details_test: pre.current_slab_details_test,
                                        slab_details_control: pre.slab_details_control,
                                        eligiblity_rules: pre.eligiblity_rules
                                      };
                              }));
                        if (state.current_base_details_test === totalTestCount) {
                          Curry._1(setActive, /* BaseDetailsControl */2);
                          return Curry._1(setCompleted, /* BaseDetailsTest */1);
                        } else {
                          return Curry._1(updateState, (function (pre) {
                                        return {
                                                key_details: pre.key_details,
                                                base_details_test: pre.base_details_test,
                                                current_base_details_test: pre.current_base_details_test + 1 | 0,
                                                base_details_control: pre.base_details_control,
                                                slab_details_test: pre.slab_details_test,
                                                current_slab_details_test: pre.current_slab_details_test,
                                                slab_details_control: pre.slab_details_control,
                                                eligiblity_rules: pre.eligiblity_rules
                                              };
                                      }));
                        }
                      }),
                    onBack: (function (param) {
                        if (state.current_base_details_test === 1) {
                          Curry._1(setActive, /* KeyDetails */0);
                          return Curry._1(resetStepper, /* BaseDetailsTest */1);
                        } else {
                          return Curry._1(updateState, (function (pre) {
                                        return {
                                                key_details: pre.key_details,
                                                base_details_test: pre.base_details_test,
                                                current_base_details_test: pre.current_base_details_test - 1 | 0,
                                                base_details_control: pre.base_details_control,
                                                slab_details_test: pre.slab_details_test,
                                                current_slab_details_test: pre.current_slab_details_test,
                                                slab_details_control: pre.slab_details_control,
                                                eligiblity_rules: pre.eligiblity_rules
                                              };
                                      }));
                        }
                      }),
                    key: "base-details-test " + String(state.current_base_details_test)
                  }),
              title: "TEST " + String(state.current_base_details_test) + " " + getTestGroup(state.current_base_details_test, state.key_details)
            });
        break;
    case /* BaseDetailsControl */2 :
        tmp = React.createElement(AbModificationForm$AbModificationWrapper, {
              children: React.createElement(AbModificationBaseDetailsForm.make, {
                    base_details: state.base_details_control,
                    core_pricing: core_pricing,
                    onNext: (function (details) {
                        Curry._1(updateState, (function (pre) {
                                return {
                                        key_details: pre.key_details,
                                        base_details_test: pre.base_details_test,
                                        current_base_details_test: pre.current_base_details_test,
                                        base_details_control: details,
                                        slab_details_test: pre.slab_details_test,
                                        current_slab_details_test: pre.current_slab_details_test,
                                        slab_details_control: pre.slab_details_control,
                                        eligiblity_rules: pre.eligiblity_rules
                                      };
                              }));
                        Curry._1(setActive, /* SlabDetailsTest */3);
                        Curry._1(setCompleted, /* BaseDetailsControl */2);
                        return scrollToRight(stepperRef);
                      }),
                    onBack: (function (param) {
                        Curry._1(setActive, /* BaseDetailsTest */1);
                        return Curry._1(resetStepper, /* BaseDetailsControl */2);
                      }),
                    key: "base-details-control"
                  }),
              title: "Control Base Details"
            });
        break;
    case /* SlabDetailsTest */3 :
        var totalTestCount$1 = Caml_format.caml_int_of_string(state.key_details.test_group);
        tmp = React.createElement(AbModificationForm$AbModificationWrapper, {
              children: React.createElement(AbModificationSlabDetailsForm.make, {
                    core_pricing: core_pricing,
                    base_details: Belt_Array.getExn(state.base_details_test, state.current_slab_details_test - 1 | 0),
                    title: getTestGroup(state.current_slab_details_test, state.key_details),
                    active_slabs: CreateModificationUtils.toCorPricingSlab(core_pricing.slabs),
                    submitted_slabs: Belt_Array.getExn(state.slab_details_test, state.current_slab_details_test - 1 | 0),
                    onNext: (function (slabs) {
                        Curry._1(updateState, (function (pre) {
                                return {
                                        key_details: pre.key_details,
                                        base_details_test: pre.base_details_test,
                                        current_base_details_test: pre.current_base_details_test,
                                        base_details_control: pre.base_details_control,
                                        slab_details_test: (Belt_Array.setExn(state.slab_details_test, state.current_slab_details_test - 1 | 0, slabs), state.slab_details_test),
                                        current_slab_details_test: pre.current_slab_details_test,
                                        slab_details_control: pre.slab_details_control,
                                        eligiblity_rules: pre.eligiblity_rules
                                      };
                              }));
                        if (totalTestCount$1 === state.current_slab_details_test) {
                          Curry._1(setActive, /* SlabDetailsControl */4);
                          return Curry._1(setCompleted, /* SlabDetailsTest */3);
                        } else {
                          return Curry._1(updateState, (function (pre) {
                                        return {
                                                key_details: pre.key_details,
                                                base_details_test: pre.base_details_test,
                                                current_base_details_test: pre.current_base_details_test,
                                                base_details_control: pre.base_details_control,
                                                slab_details_test: pre.slab_details_test,
                                                current_slab_details_test: pre.current_slab_details_test + 1 | 0,
                                                slab_details_control: pre.slab_details_control,
                                                eligiblity_rules: pre.eligiblity_rules
                                              };
                                      }));
                        }
                      }),
                    onBack: (function (param) {
                        if (state.current_slab_details_test === 1) {
                          scrollToLeft(stepperRef);
                          Curry._1(setActive, /* BaseDetailsControl */2);
                          return Curry._1(resetStepper, /* SlabDetailsTest */3);
                        } else {
                          return Curry._1(updateState, (function (pre) {
                                        return {
                                                key_details: pre.key_details,
                                                base_details_test: pre.base_details_test,
                                                current_base_details_test: pre.current_base_details_test,
                                                base_details_control: pre.base_details_control,
                                                slab_details_test: pre.slab_details_test,
                                                current_slab_details_test: pre.current_slab_details_test - 1 | 0,
                                                slab_details_control: pre.slab_details_control,
                                                eligiblity_rules: pre.eligiblity_rules
                                              };
                                      }));
                        }
                      }),
                    free_slab_params: {
                      free_kms: Belt_Option.mapWithDefault(Belt_Array.getExn(state.base_details_test, state.current_slab_details_test - 1 | 0), core_pricing.free_kms, (function (d) {
                              return d.free_kms_delta + core_pricing.free_kms | 0;
                            })),
                      price_per_min: CurrencyMajorMinorMapper.currencyToBase(Belt_Option.mapWithDefault(Belt_Array.getExn(state.base_details_test, state.current_slab_details_test - 1 | 0), core_pricing.free_km_price_per_min, (function (d) {
                                  return Currency.add(d.free_km_price_delta, core_pricing.free_km_price_per_min);
                                })))
                    },
                    key: "slab-details-test" + String(state.current_slab_details_test)
                  }),
              title: "Test " + String(state.current_slab_details_test) + " Details"
            });
        break;
    case /* SlabDetailsControl */4 :
        tmp = React.createElement(AbModificationForm$AbModificationWrapper, {
              children: React.createElement(AbModificationSlabDetailsForm.make, {
                    core_pricing: core_pricing,
                    base_details: state.base_details_control,
                    title: "Control Base Details",
                    active_slabs: CreateModificationUtils.toCorPricingSlab(core_pricing.slabs),
                    submitted_slabs: state.slab_details_control,
                    onNext: (function (slabs) {
                        Curry._1(updateState, (function (pre) {
                                return {
                                        key_details: pre.key_details,
                                        base_details_test: pre.base_details_test,
                                        current_base_details_test: pre.current_base_details_test,
                                        base_details_control: pre.base_details_control,
                                        slab_details_test: pre.slab_details_test,
                                        current_slab_details_test: pre.current_slab_details_test,
                                        slab_details_control: slabs,
                                        eligiblity_rules: pre.eligiblity_rules
                                      };
                              }));
                        Curry._1(setActive, /* EligibilityRules */5);
                        return Curry._1(setCompleted, /* SlabDetailsControl */4);
                      }),
                    onBack: (function (param) {
                        Curry._1(setActive, /* SlabDetailsTest */3);
                        return Curry._1(resetStepper, /* SlabDetailsControl */4);
                      }),
                    free_slab_params: {
                      free_kms: Belt_Option.mapWithDefault(state.base_details_control, core_pricing.free_kms, (function (d) {
                              return d.free_kms_delta + core_pricing.free_kms | 0;
                            })),
                      price_per_min: CurrencyMajorMinorMapper.currencyToBase(Belt_Option.mapWithDefault(state.base_details_control, core_pricing.free_km_price_per_min, (function (d) {
                                  return Currency.add(d.free_km_price_delta, core_pricing.free_km_price_per_min);
                                })))
                    },
                    key: "slab-details-control"
                  }),
              title: "Control Details"
            });
        break;
    case /* EligibilityRules */5 :
        tmp = React.createElement(AbEligibilityRulesForm.make, {
              eligiblity_rules: state.eligiblity_rules,
              onNext: (function (eligiblity_rules) {
                  Curry._1(updateState, (function (pre) {
                          return {
                                  key_details: pre.key_details,
                                  base_details_test: pre.base_details_test,
                                  current_base_details_test: pre.current_base_details_test,
                                  base_details_control: pre.base_details_control,
                                  slab_details_test: pre.slab_details_test,
                                  current_slab_details_test: pre.current_slab_details_test,
                                  slab_details_control: pre.slab_details_control,
                                  eligiblity_rules: eligiblity_rules
                                };
                        }));
                  Curry._1(setActive, /* Preview */6);
                  return Curry._1(setCompleted, /* EligibilityRules */5);
                }),
              onBack: (function (param) {
                  Curry._1(setActive, /* SlabDetailsControl */4);
                  return Curry._1(resetStepper, /* EligibilityRules */5);
                })
            });
        break;
    case /* Preview */6 :
        tmp = React.createElement(ModificationPreview.make, {
              modification_form_data: {
                TAG: /* AB */0,
                key_details: resolveOption(state.key_details),
                base_details_test: resolveOptionArray(state.base_details_test, Caml_format.caml_int_of_string(state.key_details.test_group)),
                base_details_control: resolveOption(state.base_details_control),
                slab_details_test: resolveOptionArray(state.slab_details_test, Caml_format.caml_int_of_string(state.key_details.test_group)),
                slab_details_control: resolveOption(state.slab_details_control),
                eligiblity_rules: resolveOption(state.eligiblity_rules)
              },
              core_pricing: core_pricing,
              close_create_modal: close_modal,
              onBack: (function (param) {
                  Curry._1(setActive, /* EligibilityRules */5);
                  return Curry._1(resetStepper, /* Preview */6);
                })
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  ref: stepperRef,
                  className: "c-stepper-wrapper"
                }, match$1.steppers_cmp), tmp);
}

var make = AbModificationForm;

export {
  resolveOption ,
  resolveOptionArray ,
  scrollTo ,
  clientWidth ,
  scrollToRight ,
  scrollToLeft ,
  AbModificationWrapper ,
  getTestGroup ,
  make ,
  
}
/* react Not a pure module */
